import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import 'mdb-react-ui-kit/dist/css/mdb.min.css';
import "@fortawesome/fontawesome-free/css/all.min.css";
import App from './App';
import reportWebVitals from './reportWebVitals';

import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { AuthProvider } from './context/AuthProvider'
//aaazserver.kanchinnotech.nl
//window.SERVER_APP_API_PHP = 'http://localhost/react/szbumusiccampmeeting2024/src/server' //server files for the POS system on local machine
//window.SERVER_APP_API_PHP = 'https://www.2024-szbu-music-campmeeting.kanchtech.com' //server files for the test POS system
//window.SERVER_APP_API_PHP = 'https://www.szbu.kanchtech.com/musiccampmeeting' //server files for the test POS system
window.SERVER_APP_API_PHP = 'https://cdf.orthopraxyministries.com'
//window.SERVER_APP_API_PHP = 'https://szu.adventist.org/2024szbumusiccampmeeting'

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path='/*' element={<App />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
